import React from 'react';

import { Alert, Stack } from '@mui/material';

import ShelfChip from './ShelfChip';
import type { PanelState } from './usePanelState';

/**
 * Region 3 as a stack of labelled shelf rows (Group by / Split by / Measure,
 * or Columns alone for a table card), each a drop target and a click target
 * for `state.setTarget`. A field's own modifier - grain, aggregate, ratio -
 * lives on its shelf chip's own menu now; the separate Combine control this
 * used to sit beside is gone.
 */
export default function Shelves({
  disabled,
  onMenuOpenChange,
  state,
}: {
  disabled?: boolean;
  onMenuOpenChange?: (open: boolean) => void;
  state: PanelState;
}) {
  return (
    <Stack spacing={0}>
      <Stack spacing={0.25}>
        {state.shelfKeys.map((key) => (
          <ShelfChip disabled={disabled} key={key} onMenuOpenChange={onMenuOpenChange} shelfKey={key} state={state} />
        ))}
      </Stack>
      {state.refusal && (
        <Alert severity="warning" sx={{ mt: 1, py: 0.25 }} variant="outlined">
          {state.refusal}
        </Alert>
      )}
      {state.clearedNote && (
        <Alert severity="info" sx={{ mt: 1, py: 0.25 }} variant="outlined">
          {state.clearedNote}
        </Alert>
      )}
    </Stack>
  );
}
